import { render } from "./CategoryClues.vue?vue&type=template&id=166b301c"
import script from "./CategoryClues.vue?vue&type=script&lang=js"
export * from "./CategoryClues.vue?vue&type=script&lang=js"

import "./CategoryClues.vue?vue&type=style&index=0&id=166b301c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__